import { FC, PropsWithChildren, Suspense } from 'react';
import TopBarProgress from 'react-topbar-progress-indicator';

export const SuspensedWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};
